/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
	SET_WORKERS(state, workers) {
		state.workers = workers
		state.loading = false
	},
	FETCH_WORKERS(state) {
		state.loading = true
	},
	// SET_LABELS(state, labels) {
	//   state.eventLabels = labels
	// },
	ADD_WORKER(state, worker) {
		state.workers.unshift(worker)
	},
	REMOVE_ITEM(state, itemId) {
		const ItemIndex = state.transactions.findIndex((p) => p.id == itemId)
		state.transactions.splice(ItemIndex, 1)
	},
}
